import { createPortal } from 'react-dom'
import type { ReactNode } from 'react'

/**
 * Saca a `body` todo lo que flota por encima de la pantalla.
 *
 * Un overlay renderizado donde se lo invoca queda preso de sus ancestros: un
 * `overflow-hidden` lo recorta, y un `transform` (las tarjetas arrastrables de
 * dnd-kit lo tienen) convierte su `position: fixed` en relativo a la tarjeta.
 * Ningún modal, panel ni popover se monta en su lugar: todos pasan por acá.
 */
export function Portal({ children }: { children: ReactNode }) {
  return createPortal(children, document.body)
}
